export default __webpack_public_path__ + "static/media/miguel-lopes-6.36422251.jpg";